import matahari from './matahari'

export default {
  matahari,
}
